import { normalize } from 'normalizr'
import { arrayOfApartments } from '../dobovoApartmentsSchema'

export default importedApartments => ({ ...normalize(importedApartments, arrayOfApartments) })



// WEBPACK FOOTER //
// ./src/adapters/parsers/importedApartments.js